var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"wgu-action-button",attrs:{"icon":"","color":"onprimary","title":_vm.$t('wgu-zoomtomaxextent.title')},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }